import GET_ARTICLES from "../class/getArticles";

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];

const domReady = () => {
  new seminarBLOCKS();
};

class seminarBLOCKS {
  constructor() {
    this.fixedBanner();
    this.seminarinfo();
  }

  seminarinfo() {
    const weekdayMap = { 'SUN': '(日)', 'MON': '(月)', 'TUE': '(火)', 'WED': '(水)', 'THU': '(木)', 'FRI': '(金)', 'SAT': '(土)' };

    const leadTarget = d.querySelector('[data-template="lead"]');
    if (leadTarget) {
      const getLead = new GET_ARTICLES('[data-template="lead"]');
      getLead.makeItem = (item) => {
        const [year, month, date, weekdayEn, startTime] = item.desc.split('/');
        return `
          <span class="year">${year}</span>
          <span class="date">${month}.${date}</span>
          <span class="weekday">(${weekdayEn})</span>
          <span class="time">${startTime} -</span>
        `;
      };
      getLead.render();
    }

    const textTarget = d.querySelector('[data-template="text"]');
    if (textTarget) {
      const getText = new GET_ARTICLES('[data-template="text"]');
      getText.makeItem = (item) => {
        const [year, month, date, weekdayEn, startTime, endTime] = item.desc.split('/');
        const weekdayJp = weekdayMap[weekdayEn] || `(${weekdayEn})`;
        return `${year}/${month}/${date}${weekdayJp} ${startTime}～${endTime}`;
      };
      getText.render();
    }
  }

  fixedBanner() {
    const closeBtn = d.getElementById('fixedSeminarBannerClose');
    const banner = d.getElementById('fixedSeminarBanner');
    
    if (closeBtn && banner) {
      closeBtn.addEventListener('click', () => {
        banner.style.display = 'none';
      });
    }
  }
}

export default function SEMINAR () {
  setTimeout(() => {
    domReady();
  }, 100);
}